const dev = {
  api: {
    private: {
      baseUrl:
        "https://070jtwqam8.execute-api.ap-southeast-2.amazonaws.com/Test",
      headers: { apikey: "YrMZqcnv4e7w8aV1StrmF8VCLERdQsGw8hkdshsm" },
    },
    webSocket: {
      baseUrl: "wss://93w1gpmnll.execute-api.ap-southeast-2.amazonaws.com/Test",
    },
  },
  hotjar: {
    hjid: 2012333,
    hjsv: 6,
  },
};

const test = {
  api: {
    private: {
      baseUrl:
        "https://070jtwqam8.execute-api.ap-southeast-2.amazonaws.com/Test",
      headers: { apikey: "YrMZqcnv4e7w8aV1StrmF8VCLERdQsGw8hkdshsm" },
    },
    webSocket: {
      baseUrl: "wss://93w1gpmnll.execute-api.ap-southeast-2.amazonaws.com/Test",
    },
  },
  hotjar: {
    hjid: 2012333,
    hjsv: 6,
  },
};

const prod = {
  api: {
    private: {
      baseUrl:
        "https://lva53xan1f.execute-api.ap-southeast-2.amazonaws.com/Prod",
      headers: { apikey: "4vOUzi2WqC1QGUf7V4ehr6JFf8V5XTHr6ProOjF7" },
    },
    webSocket: {
      baseUrl: "wss://0s0v9x67f8.execute-api.ap-southeast-2.amazonaws.com/Prod",
    },
  },
  hotjar: {
    hjid: 2012089,
    hjsv: 6,
  },
};

const prod_ssc = {
  api: {
    private: {
      baseUrl:
        "https://d9n5zjp8mg.execute-api.ap-southeast-2.amazonaws.com/Prod",
      headers: { apikey: "lEC7886S2a3VYJmr0qVHJQFPu3QDdD58vG9HGIx0" },
    },
    webSocket: {
      baseUrl: "wss://zala33859c.execute-api.ap-southeast-2.amazonaws.com/Prod",
    },
  },
  hotjar: {
    hjid: 2012089,
    hjsv: 6,
  },
};

const getEnv = function () {
  let env = process.env.REACT_APP_ENV;
  if (typeof env === "undefined") return dev;
  env = env.trim();
  if (env === "dev") {
    return dev;
  } else if (env === "test") {
    return test;
  } else if (env === "prod") {
    return prod;
  } else if (env === "prod_ssc") {
    return prod_ssc;
  } else {
    return dev;
  }
};

const config = getEnv();

export default {
  ...config,
};
